<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<ngx-spinner [style]="'color: #f5c542;'">{{ loadingText }}</ngx-spinner>
<router-outlet></router-outlet>
